/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmBaseDocumentFilter {
    flavor: string;

    protected setDiscriminator(type: string) {
        this.flavor = type;
    }

    getFixupPrototypeFunction() { return AwsSsmBaseDocumentFilter.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmBaseDocumentFilter>): AwsSsmBaseDocumentFilter {
        let obj = Object.assign(new AwsSsmBaseDocumentFilter(), model);
        AwsSsmBaseDocumentFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmBaseDocumentFilter>): AwsSsmBaseDocumentFilter {
        if (!model) return null;
        return AwsSsmBaseDocumentFilter.newInstance(<AwsSsmBaseDocumentFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmBaseDocumentFilter) {
        if (!obj) return;

        models.AwsSsmBaseDocumentFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmBaseDocumentFilter): boolean {
        switch (obj.flavor)
        {
            case "AwsSsmAutomationFilter":
                Object.setPrototypeOf(obj, models.AwsSsmAutomationFilter.prototype);
                break;
            case "AwsSsmCommandFilter":
                Object.setPrototypeOf(obj, models.AwsSsmCommandFilter.prototype);
                break;
            case "AwsSsmDocumentFilter":
                Object.setPrototypeOf(obj, models.AwsSsmDocumentFilter.prototype);
                break;
            case "AwsSsmExecutionFilter":
                Object.setPrototypeOf(obj, models.AwsSsmExecutionFilter.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof AwsSsmBaseDocumentFilter)[] {
        return [
            models.AwsSsmAutomationFilter,
            models.AwsSsmCommandFilter,
            models.AwsSsmDocumentFilter,
            models.AwsSsmExecutionFilter,
        ];
    }

    fixupFields() {
        if (this.cloud_account_details) {
            for (let val of this.cloud_account_details) {
                models.AwsSsmCloudAccount.fixupPrototype(val);
            }
        }
    }

    /**
     * Id and name of the cloud accounts.
     */
    cloud_account_details: Array<models.AwsSsmCloudAccount>;

    /**
     * Regions based on the available documents.
     */
    regions: Array<string>;

}
